import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { XStack } from 'tamagui';

import { Sidebar } from '../../components/common';
import { RouteCache } from '../../components/routing';
import { ROUTE_PATHS } from '../../routes/routeConstants';

// Routes where the sidebar should be hidden
const HIDE_SIDEBAR_ROUTES = [
  ROUTE_PATHS.water,
  ROUTE_PATHS.hvac,
  ROUTE_PATHS.air,
  ROUTE_PATHS.energy,
];

/**
 * Checks if the sidebar should be hidden based on the current route
 */
const shouldHideSidebar = (pathname: string): boolean =>
  // Check if the current path contains any of the routes where sidebar should be hidden
  HIDE_SIDEBAR_ROUTES.some((route) => pathname.includes(`/${ROUTE_PATHS.dashboard}/${route}`));

export const Dashboard: React.FC = () => {
  const { pathname } = useLocation();
  const hideSidebar = shouldHideSidebar(pathname);

  const isSettingsRoute = pathname.startsWith('/dashboard/settings');

  return (
    <XStack width="100%" height="100%" backgroundColor="$gray1">
      {/* Conditionally render the Sidebar based on the current route */}
      {!hideSidebar && <Sidebar />}

      {isSettingsRoute ? <Outlet /> : <RouteCache maxCacheSize={8} />}
    </XStack>
  );
};
